import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon } from "lucide-react";
import { DropdownMenu as Menu } from "radix-ui";
import { cn } from "../lib/cn.js";
export const DropdownMenu = Menu.Root;
export const DropdownMenuTrigger = Menu.Trigger;
export const DropdownMenuGroup = Menu.Group;
export const DropdownMenuRadioGroup = Menu.RadioGroup;
export function DropdownMenuContent({ className, sideOffset = 4, ...props }) {
    return (_jsx(Menu.Portal, { children: _jsx(Menu.Content, { sideOffset: sideOffset, className: cn("z-50 min-w-48 overflow-hidden rounded-xl border border-border bg-popover p-1.5 text-popover-foreground shadow-pop", className), ...props }) }));
}
const itemClass = "relative flex cursor-default items-center gap-2 rounded-lg px-2.5 py-2 text-sm outline-none select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:size-4 [&_svg]:text-muted-foreground";
export function DropdownMenuItem({ className, ...props }) {
    return _jsx(Menu.Item, { className: cn(itemClass, className), ...props });
}
export function DropdownMenuRadioItem({ className, children, ...props }) {
    return (_jsxs(Menu.RadioItem, { className: cn(itemClass, "pl-8", className), ...props, children: [_jsx("span", { className: "absolute left-2 flex size-4 items-center justify-center", children: _jsx(Menu.ItemIndicator, { children: _jsx(CheckIcon, {}) }) }), children] }));
}
export function DropdownMenuCheckboxItem({ className, children, ...props }) {
    return (_jsxs(Menu.CheckboxItem, { className: cn(itemClass, "pl-8", className), ...props, children: [_jsx("span", { className: "absolute left-2 flex size-4 items-center justify-center", children: _jsx(Menu.ItemIndicator, { children: _jsx(CheckIcon, {}) }) }), children] }));
}
export function DropdownMenuLabel({ className, ...props }) {
    return (_jsx(Menu.Label, { className: cn("px-2 py-1.5 text-xs font-medium text-muted-foreground", className), ...props }));
}
export function DropdownMenuSeparator({ className, ...props }) {
    return _jsx(Menu.Separator, { className: cn("-mx-1 my-1 h-px bg-border", className), ...props });
}
//# sourceMappingURL=dropdown-menu.js.map